import type { MembershipRequestDTO, MembershipRequestListParams } from "@membentry/shared-types";
import type { AxiosInstance } from "axios";
import {
  createInfiniteListQuery,
  type InfiniteListOptions,
} from "../common/infinite-list";
import { MEMBERSHIP_REQUESTS_QUERY_KEY } from "./useMembershipRequestHooks";

export const OWNER_MEMBERSHIP_REQUESTS_INFINITE_PAGE_SIZE = 20;

export type OwnerMembershipRequestsInfiniteParams = Omit<MembershipRequestListParams, "page">;

const useOwnerMembershipRequestsInfiniteList = createInfiniteListQuery<
  OwnerMembershipRequestsInfiniteParams,
  MembershipRequestDTO,
  readonly unknown[]
>({
  pageSize: (params) => params.pageSize ?? OWNER_MEMBERSHIP_REQUESTS_INFINITE_PAGE_SIZE,
  buildQueryKey: (params, pageSize) =>
    [
      MEMBERSHIP_REQUESTS_QUERY_KEY,
      "owner",
      params.clubId ?? null,
      params.status ?? null,
      "infinite",
      pageSize,
    ] as const,
  fetchPage: async (client, params, { page, pageSize }) => {
    const { getOwnerMembershipRequests } = await import("@membentry/shared-api");
    return getOwnerMembershipRequests(client, { ...params, page, pageSize });
  },
});

export function useOwnerMembershipRequestsInfiniteQuery(
  client: AxiosInstance,
  params: OwnerMembershipRequestsInfiniteParams,
  options?: InfiniteListOptions<MembershipRequestDTO, readonly unknown[]>,
) {
  return useOwnerMembershipRequestsInfiniteList(client, params, {
    enabled: !!params.clubId,
    ...options,
  });
}
